import React from 'react';
import '../index.scss';

export const ReportsAndLogsDataDetails = ({...report}) => {
    const isPost = report.method === 'post' ? true : false;
    const from = report?.email.from;
    const subject = isPost ? report.provider?.post_code : report.email.subject;
  return (
    <>
        { 
            !isPost  && 
                <div className={`${report.error_code === 14 ? 'RowDisabled' : ''} DataDetails`}>
                    {
                        report.error_code === 14 ?
                            from :
                                <strong><a href={`mailto:${from}`}>{ from }</a></strong>
                    }
                </div>
        }
        { 
            subject && isPost ?
                <div className={`${report.error_code === 14 ? 'RowDisabled' : ''} DataDetails`}>Post code: '{ subject }'</div>
            : 
                <div className={`${report.error_code === 14 ? 'RowDisabled' : ''} DataDetails`}>'{ subject }'</div>
        }
    </>
  )
}
